module.exports = __webpack_public_path__ + "img/nuxt.61df40ff.svg";